import * as yup from 'yup';
import { matchIsValidTel } from 'mui-tel-input';

/**
 * Yup schema for optional phone number validation.
 * Accepts E.164 format (e.g., "+447911123456").
 * Empty strings are considered valid for optional fields.
 */
export const optionalPhoneSchema = yup
  .string()
  .test('valid-phone', 'Please enter a valid phone number', value => {
    if (!value || value.trim() === '') return true;
    return matchIsValidTel(value);
  })
  .transform(value => value || undefined);

/**
 * Yup schema for required phone number validation.
 * Accepts E.164 format (e.g., "+447911123456").
 */
export const requiredPhoneSchema = yup
  .string()
  .required('Phone number is required')
  .test('valid-phone', 'Please enter a valid phone number', value => {
    if (!value || value.trim() === '') return false;
    return matchIsValidTel(value);
  });
